export default __webpack_public_path__ + "static/media/asiento.67ef22a3.png";